import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const dimmerClass = css({
    position: "absolute",
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
    zIndex: 1000,
});
const hiddenClass = css({
    display: "none",
});
function overlayClass(overlayOpacity) {
    return css({
        position: "absolute",
        top: "0px",
        bottom: "0px",
        left: "0px",
        right: "0px",
        backgroundColor: getThemeColorVar("white", undefined),
        opacity: overlayOpacity === undefined ? 0.9 : overlayOpacity,
    });
}
const contentClass = css({
    position: "absolute",
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
});
export const Dimmer = (props) => {
    const classes = [dimmerClass];
    !props.active && classes.push(hiddenClass);
    return (React.createElement("div", { className: cx(classes) },
        React.createElement("div", { className: cx(overlayClass(props.overlayOpacity)) }),
        React.createElement("div", { className: cx(contentClass) }, props.children)));
};
export default Dimmer;
//# sourceMappingURL=dimmer.js.map